<template>
    <div id="AssetContract">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>

        <div v-if="assetContractVal != undefined">
            <div class="internal-table-border">
                <vue-good-table
                    ref="listAssetContractTable"
                    mode="remote"
                    title="Contract"
                    @on-page-change="onPageChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: true,
                        position: 'both',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    >
                </vue-good-table>
            </div>
        </div>

        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        Assets Contract History
                    </div>
                    <div class="admin-page-content customer-detail">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <vue-good-table
                                    ref="listAssetContractTable"
                                    mode="remote"
                                    title="Contract"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: true,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    >
                                </vue-good-table>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import EventBus from ".././event-bus";
    export default {
        name: "AssetContract",
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetContractVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            columns: [
                {
                    label: '# Unit',
                    field: 'unit',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract',
                    field: 'contract',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Contract", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Effective Date',
                    field: 'effective_date',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Assigned Facility',
                    field: 'assigned_facility',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Assigned Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Termination Date',
                    field: 'termination_date',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_contract_history') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        beforeDestroy(){
            // this.$root.$off('contract_history_opted');
        },
        mounted: function() {
            var self = this;
            //self.loadList();
            // this.$root.$on('contract_history_opted', () => {

            // });
            // self.getPermissions();
            //when component list directly call from url instead of in view page than call permission request
            if ( self.assetContractVal == undefined ) {
                self.getPermissions();
            }else{
                var path = window.location.pathname;
                var asset = path.split("/");
                self.assetId = asset[3];
                self.assetContractVal = "loadList";
                self.flag = 'selectedAssetContract';

                //for now hide unit and name datatable column
                for (let index = 0; index < this.columns.length; index++) {

                    if(this.columns[index].field == 'unit' || this.columns[index].field == 'name'){
                        this.$set(this.columns[index], 'hidden', true);
                    }

                }
                // self.getPermissions();
                // self.loadList();
            }
        },
        methods: {

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },

            onPerPageChange(params) {
                var self = this;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.serverParams.page = 1 ;
                if (this.firstLoad == 1 || self.assetContractVal != 'selectedAssetContract'){
                    this.loadList();
                }
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('unit');
                    field:('name');
                    field:('contract');
                    field:('customer');
                    field:('effective_date');
                    field:('expiry_date');
                    field:('assignment_date');
                    field:('assigned_facility');
                    field:('assigned_by');
                    field:('status');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                this.serverParams.page = 1 ;
                if (this.firstLoad == 1 || filters.unit || filters.name || filters.contract || filters.customer || filters.effective_date || filters.expiry_date || filters.assignment_date || filters.assigned_facility || filters.assigned_by || filters.status) {
                    this.loadList();
                }
            },*/

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/

            loadList() {
                var self = this;
                // if(self.assetContractVal == 'selectedAssetContract'){

                //     var path = window.location.pathname;
                //     var asset = path.split("/");
                //     self.assetId = asset[3];
                //     self.flag = 'selectedAssetContract';

                //     //for now hide unit and name datatable column
                //     for (let index = 0; index < this.columns.length; index++) {

                //         if(this.columns[index].field == 'unit' || this.columns[index].field == 'name'){
                //             this.$set(this.columns[index], 'hidden', true);
                //         }

                //     }
                // }

                self.loading = true;
                if( self.assetContractVal == 'dontLoadList' ){
                    return;
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    asset_id: self.assetId
                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/assetcontract/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            }
        }
    };
</script>

<style scope>
#AssetContract .vgt-wrap {
    float: none;
}
</style>



// WEBPACK FOOTER //
// src/components/asset/AssetContracts.vue